<template>
	<div class="input-group" :class="groupClassName"> 
		<div class="input-group-prepend" v-if="hideicon">
			<span class="input-group-text">
				<span v-show="isPending" ><i class="fas fa-pulse fa-spinner"></i></span>
				<span class="iti-flag " :class="isoCodeForDesCountry?isoCodeForDesCountry.toLowerCase():''" ></span>
			</span>
		</div>
		<select @change="$emit('input', model)"  @input="$emit('input', model)" v-model="model" :id="id" :name="name"
				:class="className" class="custom-select" :disabled="disabled">
			<slot></slot>
			<option v-for="(item, index) in list" :value="item[fieldValue]" :key="index" :selected="selected(item[fieldValue])">
				<nav v-if="idOrg">{{item[fieldText]}} ({{ item[fieldValue] }})</nav>
				<nav v-else>{{item[fieldText]}}</nav>
			</option>
		</select>
		<slot name="after"></slot>
	</div> 
</template>
<script>
import { mapGetters } from 'vuex'
	export default {
		props: ['list', 'fieldValue', 'hideicon', 'fieldText', 'id', 'name', 'className', 'isPending', 'value', 'disabled',
			'groupClassName', 'idOrg'],
		data() {
			return {
				model: '',
			}
		},
		mounted() {
			this.model = this.$props.value;
		},
		watch: {
			value(before, after) {
				this.model = this.$props.value;
			}
		},
		methods: {
			selected(val) {
				return this.value == val;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/select-group.vue